export default [
  {
    path: '/admin/defines/customer-types',
    name: 'CustomerTypes',
    component: () => import('@/views/Admin/Defines/Customer_types/Index.vue'),
    meta: {
      pageTitle: 'Müşteri Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/customer-types/add',
    name: 'CustomerTypeAdd',
    component: () => import('@/views/Admin/Defines/Customer_types/Add.vue'),
    meta: {
      pageTitle: 'Müşteri Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/customer-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/customer-types/edit/:id',
    name: 'CustomerTypeEdit',
    component: () => import('@/views/Admin/Defines/Customer_types/Edit.vue'),
    meta: {
      pageTitle: 'Müşteri Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/customer-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
